import { MouseEventHandler } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { TpSlPriceButtonSet, TpSlTriggerTimeIndicatorMapper } from '@flipster/features/src/tpsl-modal/constant';
import Num, { BigNumber } from '@flipster/utils/num';
import { V2OrderSideType } from '@flipster/utils/types/base';

import PriceRateButtons from '@web/components/PriceRateButtons';

import { TpslTimeTriggerSchema } from '../../bunja/validation';
import styles from '../../tpslModal.module.scss';

interface Props extends Omit<TpslTimeTriggerSchema, 'positionType' | 'leverage' | 'maintMarginRate'> {
  side: V2OrderSideType;
  tpSlType: 'tp' | 'sl';
  precision: number;
}

const TriggerPriceRatioRate = ({ side, tpSlType, precision }: Props) => {
  const { control, setValue } = useFormContext<TpslTimeTriggerSchema>();
  const triggerPriceRatio = useWatch({ control, name: 'triggerPriceRatio' }) || '0';

  const onClickPercent: MouseEventHandler<HTMLButtonElement> = (e) => {
    const { value } = e.currentTarget;

    const valueToBeAdded =
      TpSlTriggerTimeIndicatorMapper[side][tpSlType] === '+' ? Num(value) : Num(value).multipliedBy(-1);
    const nextPrice = BigNumber.max(Num(0), BigNumber.min(Num(9999.99), Num(triggerPriceRatio).plus(valueToBeAdded)));

    setValue('triggerPriceRatio', nextPrice.toFixed(precision, BigNumber.ROUND_HALF_UP).toString(), {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true,
    });
  };

  const buttonItems = TpSlPriceButtonSet[side]?.[tpSlType];

  return <PriceRateButtons items={buttonItems} onClick={onClickPercent} className={styles.priceButton} />;
};

export default TriggerPriceRatioRate;
